import {useActions, useGetters, useMutators, useState} from './_default';
export default {
    namespaced: true,
    state: {
        ...useState(),
        enabled: false,
        redirected: false,
    },
    getters: {
        ...useGetters(),
        enabled: state => state.enabled,
        redirected: state => state.redirected,
    },
    mutations: {
        ...useMutators(),
        enabled(state, status) {
            state.enabled = status;
        },
        redirected(state, status) {
            state.redirected = status;
        },
        layout(state, layout) {
            state.layout = layout;
        }
    },
    actions: {
        ...useActions(),
    },
}
